/* Skapad av Claude Code – A/B-test av varukorgen (styrs från SVD Functions-appen).
 *
 * Läser experimentet ur #svd-ab-config (renderas av svd-cart-core-v3.liquid från
 * shop-metafältet svd.ab_experiment), bucketar besökaren 50/50 i localStorage,
 * visar variantens slots (element med data-svd-ab-slot) och stämplar varukorgen
 * med cart attribute _svd_ab = "<experimentId>:<variant>" så att ordern kan
 * attribueras i statistiken (SVD Functions → Statistik).
 *
 * CSS:en i core-sektionen döljer experimentets slots tills klassen svd-ab-on
 * sätts här — ingen flicker, ingen dubbelvisning. Sektionerna re-renderas
 * serverside vid varje cart-ändring, så klasserna sätts om på svd-cart:updated.
 */
(function () {
  'use strict';

  var configEl = document.getElementById('svd-ab-config');
  if (!configEl) return;

  var exp;
  try { exp = JSON.parse(configEl.textContent); } catch (e) { return; }
  if (!exp || !exp.id || !Array.isArray(exp.variants) || exp.variants.length < 2) return;

  // ---- Bucketing: samma besökare behåller sin variant experimentet ut ----
  var storageKey = 'svd_ab_' + exp.id;
  var variantKeys = exp.variants.map(function (v) { return v.key; });
  var variant = null;
  try { variant = localStorage.getItem(storageKey); } catch (e) {}
  if (variantKeys.indexOf(variant) === -1) {
    var split = typeof exp.split === 'number' ? exp.split : 50;
    variant = Math.random() * 100 < split ? variantKeys[0] : variantKeys[1];
    try { localStorage.setItem(storageKey, variant); } catch (e) {}
  }

  function findVariant(key) {
    for (var i = 0; i < exp.variants.length; i += 1) {
      if (exp.variants[i].key === key) return exp.variants[i];
    }
    return null;
  }

  var chosen = findVariant(variant);
  if (!chosen) return;

  var applied = null; // varianten som faktiskt visas (kan bli A-fallback vid rabattest)

  // ---- Visa variantens slots (CSS:en döljer resten) ----
  function apply(v) {
    exp.variants.forEach(function (other) {
      (other.slots || []).forEach(function (slot) {
        var show = v.slots.indexOf(slot) !== -1;
        var nodes = document.querySelectorAll('[data-svd-ab-slot="' + slot + '"]');
        for (var n = 0; n < nodes.length; n += 1) {
          nodes[n].classList.toggle('svd-ab-on', show);
        }
      });
    });
    applied = v;
    // Övriga skript (popup, sparbanner …) läser tilldelningen härifrån.
    window.svdAb = { id: exp.id, variant: v.key };
    document.dispatchEvent(new CustomEvent('svd-ab:applied', { detail: window.svdAb }));
  }

  // ---- Stämpla varukorgen (samma attribut-mönster som _wheel_spun) ----
  function stamp(key) {
    var payload = {};
    payload['_svd_ab'] = exp.id + ':' + key;
    return fetch('/cart/update.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ attributes: payload })
    });
  }

  function init() {
    if (exp.type === 'discount') {
      // Rabattest: stämpla FÖRST, visa sen. Motorn debiterar B-nivån bara när
      // attributet är stämplat — att visa B-priset före lyckad stämpling vore
      // att visa mer rabatt än vad som debiteras (förbjudet). Misslyckas
      // stämplingen visas variant A (kontrollen) och B-nyckeln rensas så att
      // nästa sidladdning försöker igen.
      stamp(variant)
        .then(function (res) {
          if (!res || !res.ok) throw new Error('stamp failed');
          apply(chosen);
        })
        .catch(function () {
          if (variant !== variantKeys[0]) {
            try { localStorage.removeItem(storageKey); } catch (e) {}
          }
          apply(findVariant(variantKeys[0]) || chosen);
        });
    } else {
      // Content-experiment: exakt dagens ordning (visa direkt, stämpla i bakgrunden).
      apply(chosen);
      stamp(variant).catch(function () {});
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Deals-sektionerna byts ut serverside vid varje cart-ändring → sätt om
  // klasserna för den variant som faktiskt visas (kan vara A-fallbacken).
  document.addEventListener('svd-cart:updated', function () {
    if (applied) apply(applied);
  });
})();
